// extracted by mini-css-extract-plugin
export default {"wrapper":"FullScreenFallbackLayout_wrapper__zi1j0","loading-indicator":"FullScreenFallbackLayout_loading-indicator__aF2aw"};